import { uploadOnboardingImage } from 'lib/api/file/uploadOnboardingImage'
import { useMutation } from '@tanstack/react-query'

const useUploadOnboardingImageMutate = () => {
  return useMutation((payload) => uploadOnboardingImage(payload))
}

export default useUploadOnboardingImageMutate